module.exports = __webpack_public_path__ + "static/media/utility_pole.68afe0fb.jpg";